<div class="container-aws-ses">
  <div class="aws-ses-scroll">
    <div class="label-lateral">
      <span class="label">Configurações de envio</span>
    </div>

    <div class="container-aws-ses__content flex-direction-column gap-15">
      <app-slide-toggle-padrao
        [carregandoInfo]="carregando"
        [valor]="parametro.ativo"
        (changeValue)="parametro.ativo = $event">
      </app-slide-toggle-padrao>

      <app-form-field
        label="Token"
        heightFormField="35px"
        [maxLengthFormFiles]="256"
        [carregandoInfo]="carregando"
        [value]="parametro.token"
        (changeValue)="parametro.token = $event">
      </app-form-field>

      <app-form-field
        label="Remetente"
        heightFormField="35px"
        [maxLengthFormFiles]="32"
        [carregandoInfo]="carregando"
        [value]="parametro.remetente"
        (changeValue)="parametro.remetente = $event">
      </app-form-field>

      <app-form-field
        label="Valor por mensagem"
        heightFormField="35px"
        type="number"
        [textPrefix]="obterSimboloMoeda()"
        [step]="0.001"
        [min]="0"
        placeholder="0.000"
        [carregandoInfo]="carregando"
        [value]="parametro.valorMensagem"
        (changeValue)="atribuirValorMensagem($event)">
      </app-form-field>

      <app-select-one
        label="Moeda do valor por mensagem"
        widthFormField="100%"
        heightFormField="35px"
        campo="nome"
        [listaInput]="opcoesMoeda"
        [itemSelecionado]="obterMoeda()"
        (selecionarItem)="selecionarMoeda($event)">
      </app-select-one>
    </div>

    <div class="label-lateral secao-api">
      <span class="label">Conexão com api-integrax-sms</span>
    </div>

    <div class="container-aws-ses__content flex-direction-column gap-15">
      <app-form-field
        label="Usuário"
        heightFormField="35px"
        [maxLengthFormFiles]="256"
        [carregandoInfo]="carregando"
        [value]="parametro.usuario"
        (changeValue)="parametro.usuario = $event">
      </app-form-field>

      <app-form-field
        label="Senha"
        heightFormField="35px"
        [isSenha]="true"
        [maxLengthFormFiles]="256"
        [carregandoInfo]="carregando"
        [value]="parametro.senha"
        (changeValue)="parametro.senha = $event">
      </app-form-field>
    </div>
  </div>

  <div class="aws-ses-rodape">
    <app-button-padrao
      width="100%"
      [label]="salvando ? 'Salvando...' : 'Salvar'"
      backgroundColor="var(--verde-padrao)"
      color="white"
      [disabled]="salvando"
      (buttonClick)="salvar()">
    </app-button-padrao>
  </div>
</div>
